import { useEffect, useRef } from 'react';
import { useGetPromoPostsQuery } from '../../../../redux/api/fymAPI';
import type { GetPromoCalendarResponse } from '../types';

interface UseDeepLinkedPostProps {
  accountId: number;
  postUuid: string | null;
  data: GetPromoCalendarResponse | undefined;
  setAnchor: (day: Date) => void;
}

/**
 * A push or an email link opens `?post=<uuid>` (or the old `postId`). When the post is not in the
 * range on the screen, this reads the posts of the account once and moves the Calendar to the day
 * of the post. The day panel then opens on it.
 */
export function useDeepLinkedPost({ accountId, postUuid, data, setAnchor }: UseDeepLinkedPostProps): void {
  const isInRange = data === undefined || postUuid === null || data.posts.some((post) => post.uuid === postUuid);
  const handled = useRef<string | null>(null);
  const { data: all } = useGetPromoPostsQuery({ accountId }, { skip: isInRange || handled.current === postUuid });

  useEffect(() => {
    if (isInRange || postUuid === null || all === undefined || handled.current === postUuid) {
      return;
    }
    handled.current = postUuid;
    const post = all.posts.find((one) => one.uuid === postUuid);
    if (post !== undefined) {
      setAnchor(new Date(post.scheduledAt));
    }
  }, [all, isInRange, postUuid, setAnchor]);
}
